import(/* webpackMode: "eager" */ "/home/runner/work/hg1/hg1/lp/node_modules/next/dist/client/image-component.js")